// @ts-nocheck
/**
 *
 * @deprecated Use readDicomTags from @itk-wasm/dicom instead
 */
async function readDICOMTagsArrayBuffer(webWorker, arrayBuffer, tags = null) {
    throw new Error('readDICOMTagsArrayBuffer is deprecated. Use readDicomTags from @itk-wasm/dicom instead.');
}
export default readDICOMTagsArrayBuffer;
//# sourceMappingURL=read-dicom-tags-array-buffer.js.map